<template>
  <el-dialog :title="dataForm.id ? 'Edit Client' : 'Add Client'" :close-on-click-modal="false" :visible.sync="visible" width="780px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="186px">
      <el-form-item label="Copy From" prop="copyFromId" v-if="!dataForm.id">
        <engagement-select-remote-search
          v-model="dataForm.copyFromId"
          placeholder="Select an existing data to copy"
          @change-item="copyFromChange"
        ></engagement-select-remote-search>
      </el-form-item>
      <el-form-item prop="clientCode">
        <span slot="label">
          Client Code
          <el-popover placement="bottom" trigger="hover">
            <span class="fs12">Data Source: "Client Code" section of this system</span>
            <span slot="reference" class="pearl-blue fs16 el-icon-warning"></span>
          </el-popover>
        </span>
        <client-code-select-remote-search v-model="dataForm.clientCode" placeholder="Client Code"></client-code-select-remote-search>
      </el-form-item>
      <el-form-item label="UEN" prop="uen">
        <el-input v-model="dataForm.uen" placeholder="UEN" clearable></el-input>
      </el-form-item>
      <el-form-item label="Entity Name" prop="companyName">
        <el-input v-model="dataForm.companyName" placeholder="Entity Name" clearable></el-input>
      </el-form-item>
      <el-form-item label="Entity Country" prop="companyCountry">
        <el-select v-model="dataForm.companyCountry" placeholder="Select Entity Country" filterable class="wdb100">
          <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Entity Type" prop="companyType">
        <el-select v-model="dataForm.companyType" placeholder="Select Entity Type" filterable class="wdb100">
          <el-option v-for="item in engagementCompanyTypeList" :key="item.title" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <div class="flex">
        <el-form-item label="Covered Period" prop="coveredPeriodStart">
          <el-date-picker
            v-model="dataForm.coveredPeriodStart"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="Start Date"
            class="wd256"
          ></el-date-picker>
        </el-form-item>
        <span class="lh36 pl15 pr15">~</span>
        <el-form-item prop="coveredPeriodEnd" class="labelNone">
          <el-date-picker v-model="dataForm.coveredPeriodEnd" type="date" value-format="yyyy-MM-dd" placeholder="End Date" class="wd256"></el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="Incorp. date" prop="incorpDate">
        <el-date-picker
          v-model="dataForm.incorpDate"
          type="date"
          placeholder="Incorp. date"
          :format="dataForm.incorpDate ? `dd [${monthList[parseInt(dataForm.incorpDate.split('-')[1]) - 1]}] yyyy` : 'dd MM yyyy'"
          value-format="yyyy-MM-dd"
          class="wdb100"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="Previous Entity Name" prop="previousCompanyName">
        <el-input v-model="dataForm.previousCompanyName" placeholder="Previous Entity Name" clearable></el-input>
      </el-form-item>
      <el-form-item label="Type" prop="type">
        <el-input v-model="dataForm.type" placeholder="Type" clearable v-regexFilter="halfWidthRegex"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import EngagementSelectRemoteSearch from "@/components/SelectRemoteSearch/engagement";
import ClientCodeSelectRemoteSearch from "@/components/SelectRemoteSearch/clientCode";
import { mapState } from "vuex";
export default {
  components: {
    EngagementSelectRemoteSearch,
    ClientCodeSelectRemoteSearch,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        copyFromId: null,
        clientCode: "",
        uen: "",
        companyName: "",
        companyCountry: "",
        companyType: "",
        coveredPeriodStart: "",
        coveredPeriodEnd: "",
        incorpDate: "",
        previousCompanyName: "",
        type: "",
      },
      dataRule: {
        clientCode: [{ required: true, message: "please select", trigger: "submit" }],
        uen: [{ required: true, message: "please select", trigger: "submit" }],
        companyName: [{ required: true, message: "please enter", trigger: "submit" }],
        companyCountry: [{ required: true, message: "please select", trigger: "submit" }],
        companyType: [{ required: true, message: "please select", trigger: "submit" }],
        coveredPeriodStart: [{ required: true, message: "please select", trigger: "submit" }],
        coveredPeriodEnd: [{ required: true, message: "please select", trigger: "submit" }],
        previousCompanyName: [{ required: true, message: "please enter", trigger: "submit" }],
      },
      monthList: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "engagementCompanyTypeList"]),
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        // 修改
        this.dataForm = {
          id: data.id,
          copyFromId: null,
          clientCode: data.clientCode,
          uen: data.uen,
          companyName: data.companyName,
          companyCountry: data.companyCountry,
          companyType: data.companyType,
          coveredPeriodStart: data.coveredPeriodStart,
          coveredPeriodEnd: data.coveredPeriodEnd,
          incorpDate: data.incorpDate,
          previousCompanyName: data.previousCompanyName,
          type: data.type,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = { ...this.dataForm };
      if (params.id) {
        return await this.$http.post(`/admin/engagementManage/${params.id}/modify`, params);
      } else {
        return await this.$http.post("/admin/engagementManage/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest(this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // Copy From 选中值发生改变时
    copyFromChange(data) {
      if (!data) return;
      this.$set(this.dataForm, "clientCode", data.clientCode || "");
      this.$set(this.dataForm, "uen", data.uen || "");
      this.$set(this.dataForm, "companyName", data.companyName || "");
    },
  },
};
</script>

<style lang="scss" scoped>
.labelNone {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
